import { FileConverter } from "us.collection.input-output/constants/Actions";
import { initialState } from "./State";
import _ from "lodash";

const {
  PREVIEW_FILE_START,
  PREVIEW_FILE_SUCCESS,
  PREVIEW_FILE_FAIL,
  RESET_FILE_IMPORT,

  IMPORT_FILE_START,
  IMPORT_FILE_SUCCESS,
  IMPORT_FILE_FAIL,

  UPDATE_FILE_LIST,

  GET_MAPPING_PROFILES_START,
  GET_MAPPING_PROFILES_SUCCESS,
  GET_MAPPING_PROFILES_FAIL,
} = FileConverter;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case PREVIEW_FILE_START:
      return {
        ...state,
        preview: {
          data: {},
          isLoading: true,
        },
        initialValues: {
          fileType: payload.data?.fileType,
          creditor: payload.data?.creditor,
        },
      };
    case PREVIEW_FILE_SUCCESS:
      return {
        ...state,
        preview: {
          data: payload.data,
          isLoading: false,
        },
      };
    case PREVIEW_FILE_FAIL:
      return {
        ...state,
        preview: {
          data: {},
          isLoading: false,
        },
      };
    case RESET_FILE_IMPORT:
      return {
        ...state,
        ...initialState,
        creditorsAndProfiles: state.creditorsAndProfiles,
      };
    case IMPORT_FILE_START:
      return {
        ...state,
        importFiles: {
          data: {},
          isLoading: true,
        },
        initialValues: {
          fileType: payload.data?.fileType,
          creditor: payload.data?.creditor,
        },
      };
    case IMPORT_FILE_SUCCESS:
      return {
        ...state,
        ...initialState,
        importFiles: {
          data: payload.data || {},
          isLoading: false,
        },
        creditorsAndProfiles: state.creditorsAndProfiles,
      };
    case IMPORT_FILE_FAIL:
      return {
        ...state,
        importFiles: {
          data: {},
          isLoading: false,
        },
      };
    case UPDATE_FILE_LIST:
      return {
        ...state,
        fileList: payload.data,
      };

    case GET_MAPPING_PROFILES_START:
      return {
        ...state,
        creditorsAndProfiles: {
          data: [],
          isLoading: true,
        },
      };
    case GET_MAPPING_PROFILES_SUCCESS:
      return {
        ...state,
        creditorsAndProfiles: {
          data: payload.data || [],
          isLoading: false,
        },
      };
    case GET_MAPPING_PROFILES_FAIL:
      return {
        ...state,
        creditorsAndProfiles: {
          data: [],
          isLoading: false,
        },
      };
    default:
      return state;
  }
};
